import { render, staticRenderFns } from "./coinmanage.vue?vue&type=template&id=166c0229"
import script from "./coinmanage.vue?vue&type=script&lang=js"
export * from "./coinmanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports